import {
  AUTH_COOKIE_SAME_SITE,
  serverAuthProviderCookieIdentity,
} from '@/utils/auth/authProviderCookie';

export const AUTH0_CIBA_SESSION_COOKIE = 'heidi-auth0-session-method';
export const AUTH0_CIBA_IDENTITY_BROKER_SESSION = 'ciba_identity_broker';

export const serverAuth0CibaSessionCookieAttrs = {
  ...serverAuthProviderCookieIdentity,
  httpOnly: true,
  secure: true,
  sameSite: AUTH_COOKIE_SAME_SITE,
} as const;
